




























import Vue from "vue";
export default Vue.extend({
  name: "base-editable-field",
  data: () => ({
    enableActions: false,
    editMode: false,
    value_: ""
  }),
  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onEdit(value: string) {
      this.editMode = false;
      // this.value_ = value;

      this.$emit("edit", value);
    },
    edit() {
      this.editMode = true;
    }
  },
  mounted() {
    this.value_ = this.value;
  }
});
